import { LinkType } from "src/services/common/common.types";

export enum EntityLinkType {
  PRIMARY = 'primary',
  OTHER = 'other'
}

export const LinkTypeMeta = {
  [LinkType.GITHUB]: {
    icon: 'carbon:logo-github',
    label: 'GitHub',
  },
  [LinkType.LINKEDIN]: {
    icon: 'brandico:linkedin-rect',
    label: 'LinkedIn',
  },
  [LinkType.X]: {
    icon: 'prime:twitter',
    label: 'X',
  },
  [LinkType.FACEBOOK]: {
    icon: 'brandico:facebook-rect',
    label: 'Facebook',
  },
  [LinkType.WEBSITE]: {
    icon: 'solar:global-outline',
    label: 'Website',
  }
};

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc'
}

// Advanced search types

export type SearchOperator =
  | 'match_phrase'
  | 'eq' | 'neq'
  | 'in' | 'nin'
  | 'contains_any' | 'contains_all'
  | 'gt' | 'gte' | 'lt' | 'lte';

// Boolean operators
export type BoolOperator = 'AND' | 'OR' | 'NOT';

// Search atom for a single field search
export interface SearchAtom {
  field: string;
  operator: SearchOperator;
  variant?: string;
  value: any;
}

export type BoolNode = {
  op: BoolOperator;
  children: (BoolNode | SearchAtom)[];
};

// CSV import

/**
 * One spreadsheet row for a CSV import endpoint: the raw cell text keyed by the backend's row
 * field, plus `custom_fields` keyed by config id. The backend parses and validates every value.
 */
export type CsvImportRow = Record<string, string | Record<string, string>>;

/**
 * What happened to a row. `unchanged` is an existing record the row had nothing new for; `skipped`
 * is an existing record left alone because the import was told to skip duplicates.
 */
export type CsvImportRowOutcome = 'created' | 'updated' | 'unchanged' | 'skipped' | 'failed';

/** A blank field the import filled on an existing record, keyed as the import row names it. */
export interface CsvImportFilledField {
  /** The row key (e.g. `phone_number`), or `cf:<config id>` for a custom field. */
  field: string;
  value: string;
}

/** What a CSV import endpoint reports for each row. */
export interface CsvImportRowResult {
  status: 'success' | 'failed';
  outcome: CsvImportRowOutcome;
  /** The record created, or the existing record the row matched. */
  id?: string;
  message?: string;
  /** Values skipped on a row that was still saved, e.g. an unrecognised dropdown value. */
  warnings?: string[];
  filled?: CsvImportFilledField[];
  added_to_list?: boolean;
}

/** How a CSV import treats rows that match existing records, and the list it adds records to. */
export interface CsvImportOptions {
  on_duplicate: 'enrich' | 'skip';
  /** An existing list by id, or a new list by name. */
  list?: { id: string } | { name: string };
}

/** What a CSV import endpoint returns once it has queued the import to run in the background. */
export interface QueuedCsvImport {
  task_id: string;
  /** How many rows were queued. */
  total: number;
}